module.exports = __webpack_public_path__ + "img/logo-cb.18ed2d04.jpg";